import { useTranslation } from 'react-i18next';
import { Package } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/atoms/card';
import { Badge } from '@/components/atoms/badge';

interface ProductInventoryDisplayProps {
  stock: number;
  sku?: string;
  unit?: string;
}

export function ProductInventoryDisplay({ stock, sku, unit }: ProductInventoryDisplayProps) {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Package className="size-5" />
          {t('products.inventory')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <span>{t('products.stock')}</span>
          <Badge variant={stock > 0 ? 'default' : 'destructive'}>
            {stock} {t('products.inStock')}
          </Badge>
        </div>

        {sku && (
          <div className="flex items-center justify-between">
            <span>SKU</span>
            <span className="font-mono text-sm">{sku}</span>
          </div>
        )}

        {unit && (
          <div className="flex items-center justify-between">
            <span>{t('products.unit')}</span>
            <span>{t(`products.units.${unit}`, { defaultValue: unit })}</span>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
